export default __webpack_public_path__ + "static/media/dealership.7536ddc9.jpg";